// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2tcQC","colBig":"styles_colBig__R4VlB","colSmall":"styles_colSmall__2XsN0","shopifyNameWrapper":"styles_shopifyNameWrapper__2MJYq"};